export default {"src":"/_next/static/media/corn.2ed5e98c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};